import { render, staticRenderFns } from "./installmentPayuotDetailOrderlist.vue?vue&type=template&id=97ad9dee&scoped=true"
import script from "./installmentPayuotDetailOrderlist.vue?vue&type=script&lang=js"
export * from "./installmentPayuotDetailOrderlist.vue?vue&type=script&lang=js"
import style0 from "./installmentPayuotDetailOrderlist.vue?vue&type=style&index=0&id=97ad9dee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ad9dee",
  null
  
)

export default component.exports